export default "__VITE_ASSET__cf8e8d44__"